import * as yup from 'yup';

import { StringParam, withDefault } from '@blockworks/platform/libs/use-query-params';

import { SHARE_FEEDBACK_OPTIONS } from '@/api/slack/internal/internal-slack.model';

const shareFeedbackFormSchema = yup.object().shape({
    description: yup.string().required('Description is required.'),
    category: yup.string().required('Category is required.'),
});

const DEFAULT_CATEGORY = SHARE_FEEDBACK_OPTIONS[2]?.value;

const shareFeedbackModalParams = {
    modalCategory: withDefault(StringParam, DEFAULT_CATEGORY),
};

export { DEFAULT_CATEGORY, shareFeedbackFormSchema, shareFeedbackModalParams };
